import NiceModal from '@ebay/nice-modal-react';

import { useState } from 'react';

import Modal from 'components/global/Modal';

import Skeleton from './Skeleton';
import * as S from './styled/VideoPreview.styled';

const VideoPreview = ({ videoLink }) => {
	const [videoLoaded, setVideoLoaded] = useState(false);
	return (
		<S.GifWrapper
			onClick={(e) => {
				e.stopPropagation();
				NiceModal.show(VideoPreviewModal, { videoLink });
			}}
			key={videoLink}>
			{!videoLoaded && <Skeleton width={'100%'} height={'100%'} />}
			<video
				autoPlay
				playsInline
				loop
				muted
				width={'100%'}
				height={'100%'}
				onLoadedData={() => setVideoLoaded(true)}>
				<source src={videoLink} type="video/mp4" />
			</video>
		</S.GifWrapper>
	);
};

const VideoPreviewModal = NiceModal.create(({ videoLink }) => {
	return (
		<Modal maxWidth="x-large" fullwidth closeButton className="modal-confirmation">
			<S.GifModal>
				<video autoPlay playsInline controls loop muted width={'100%'}>
					<source src={videoLink} type="video/mp4" />
				</video>
			</S.GifModal>
		</Modal>
	);
});

export default VideoPreview;
